import { useCallback } from 'react';

import ScreenshotAnnotator from 'components/shared/others/screenshot-annotator/screenshot-annotator';
import type { AnnotationNote } from 'components/shared/others/screenshot-annotator/screenshot-annotator';
import { ViewWrapper } from 'components/partials/insight-modal/shared/components';

import { useInsight } from 'components/partials/insight-modal/insight-context';
import type { InsightNote } from 'components/partials/insight-modal/insight-context';

interface AnnotateStepProps {
  imageUrl: string | null;
}

const AnnotateStep = ({ imageUrl }: AnnotateStepProps) => {
  const { state: insightState, dispatch } = useInsight();

  const initialNotes: AnnotationNote[] = (insightState.notes || []).map(
    (note) => ({
      id: note.id,
      xPct: note.xPct ?? 0,
      yPct: note.yPct ?? 0,
      text: note.text ?? '',
    })
  );

  const handleChange = useCallback(
    (updated: AnnotationNote[]) => {
      dispatch({ type: 'setNotes', payload: updated as InsightNote[] });
    },
    [dispatch]
  );

  return (
    <ViewWrapper>
      <ScreenshotAnnotator
        imageSrc={imageUrl}
        initialNotes={initialNotes}
        onChange={handleChange}
      />
    </ViewWrapper>
  );
};

export default AnnotateStep;
